import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { notification, Modal, Button, Descriptions, Spin, Table } from 'antd';

@inject("transStore")
@observer
class TrackerSearch extends Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen && nextProps.modalOpen === true) {
      if (nextProps.tracker !== undefined && nextProps.tracker !== null 
        && nextProps.invoiceNo !== undefined && nextProps.invoiceNo !== null) {
          this.getDelivery(nextProps.tracker, nextProps.invoiceNo);
        }
    }
  }

  // 배송 조회
  getDelivery = (carrierId, trackId) => {
    if (carrierId === '' || trackId === '') {
      notification.error({placement: 'bottomLeft', message: `배송정보를 확인하세요.`, duration: 2});
      return;
    }
    this.props.transStore.disDeliveryInfo(carrierId, trackId);
  };

  render() {
    const { 
      // carriersList,
      deliveryInfo,
      deliveryInfoLoding
    } = this.props.transStore;
    const { 
      modalOpen,
      modalClose,
      // tracker,
      invoiceNo,
      // orInvoiceNoEtc
    } = this.props;
    const columns = [
      { title: '시간', dataIndex: 'time', width: '25%', align: 'center',
        render: (item, record) => { return(
          item !== undefined && item !== null && moment(item).format('YYYY-MM-DD hh:mm:ss')
        )}
      },
      { title: '현재위치', dataIndex: 'location', width: '15%', align: 'center',
        render: (item, record) => { return(
          (item !== undefined && item !== null 
          && item.name !== undefined && item.name !== null)
          && item.name
        )}
      },
      { title: '상태', dataIndex: 'status', width: '15%', align: 'center',
        render: (item, record) => { return(
          (item !== undefined && item !== null 
          && item.text !== undefined && item.text !== null)
          && item.text
        )}
      },
      { title: '상세', dataIndex: 'description', width: '45%', align: 'left',
        render: (item, record) => { return(
          item !== undefined && item !== null && item
        )}
      },
    ];
    return (
      <Modal
        width={1000}
        title="배송조회"
        cancelText={"취소"}
        okText={"확인"}
        closable={false}
        visible={modalOpen}
        onCancel={modalClose}
        footer={
          <Button
            onClick={modalClose}
          >닫기</Button>
        }
      >
        {(deliveryInfoLoding === true)
        ? <div style={{
            textAlign: 'center',
            borderRadius: '4px',
            marginBottom: '20px',
            padding: '50px 50px',
            margin: '20px 0'
          }}>
            <Spin 
              tip="조회중..." 
              spinning={deliveryInfoLoding}
              size="large"
            />
          </div>
        : deliveryInfo === null
          ? <Fragment>
              <h1 style={{color: 'red'}}>배송조회가 실패하였습니다.</h1>
            <br />
            {invoiceNo !== undefined && invoiceNo !== null && 
            <Fragment>
              운송장번호: {invoiceNo}
              {/* <br />
              운송장번호(추가): {orInvoiceNoEtc} */}
            </Fragment>
            }
          </Fragment>
          :
          <Fragment>
            <h3 className="h3_st">▶ 기본정보</h3>
            <div className="table_th_W">
              <Descriptions bordered >
                <Descriptions.Item label="받는사람" span={3}>
                  {deliveryInfo.to !== undefined && deliveryInfo.to !== null && deliveryInfo.to
                  && deliveryInfo.to.name !== undefined && deliveryInfo.to.name !== null && deliveryInfo.to.name}
                </Descriptions.Item>
                <Descriptions.Item label="택배사" span={3}>
                  {deliveryInfo.carrier !== undefined && deliveryInfo.carrier !== null 
                  && deliveryInfo.carrier.name !== undefined && deliveryInfo.carrier.name !== null &&
                  deliveryInfo.carrier.name}
                  {deliveryInfo.carrier !== undefined && deliveryInfo.carrier !== null 
                  && deliveryInfo.carrier.tel !== undefined && deliveryInfo.carrier.tel !== null &&
                  <Fragment>( {deliveryInfo.carrier.tel} )</Fragment>}
                </Descriptions.Item>
                <Descriptions.Item label="송장번호" span={3}>
                  {invoiceNo !== undefined && invoiceNo !== null 
                  && invoiceNo }
                </Descriptions.Item>
                {/* <Descriptions.Item label="송장번호(추가)" span={3}>
                  {orInvoiceNoEtc !== undefined && orInvoiceNoEtc !== null 
                  && orInvoiceNoEtc }
                </Descriptions.Item> */}
              </Descriptions>
            </div>
            <h3 className="h3_st">▶ 배송상태</h3>
            {deliveryInfo.progresses !== undefined && deliveryInfo.progresses !== null &&
              <Fragment>
                <Table
                  rowKey={(record)=>record.time}
                  columns={columns} 
                  dataSource={deliveryInfo.progresses}
                  pagination={false}
                  scroll={{ y: 400 }}
                />
              </Fragment>
            }
          </Fragment>
        }
        
        
        
      </Modal>
    );
  }

}

export default TrackerSearch;
